"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDatasetProduct = void 0;
const routes_1 = require("../../routes");
const createDatasetProduct = (client) => async (payload) => {
    const response = await client.post(routes_1.ENDPOINTS.CREATE_DATASET_PRODUIT.path, payload);
    return response.data;
};
exports.createDatasetProduct = createDatasetProduct;
